import { CSSProperties, ReactElement } from "react";

export enum EButtonKind {
  DANGER = "DANGER",
  NORMAL = "NORMAL",
  EDIT = "EDIT",
  SAVE = "SAVE",
  GHOST = "GHOST",
}

export interface IButton {
  type?: "button" | "reset" | "submit";
  onClick: (e: any) => void;
  kind?: EButtonKind;
  icon?: ReactElement;
  text?: string;
  disabled?: boolean;
  form?: string;
  tooltip?: string;
  active?: boolean;
  className?: string;
  hide?: boolean;
  isLoading?: boolean;
  autoFocus?: boolean;
  theme?: "light" | "dark";
  notify?: boolean;
  animate?: boolean;
  capitalize?: boolean;
  style?: CSSProperties;
  highlight?: boolean;
}
